import { FabricationJobState } from '../../api/fabrication-job-api';

/**
 * Client mirror of the server's FabricationJobStateTransitions table. Draft is
 * absent on purpose: Draft to Planned belongs to Lock In on the optimization
 * panel, which carries guards a plain transition button must not bypass.
 */
const allowedTransitions: ReadonlyMap<FabricationJobState, readonly FabricationJobState[]> = new Map([
  [FabricationJobState.Planned, [FabricationJobState.AwaitingOrder, FabricationJobState.ReadyForProduction]],
  [FabricationJobState.AwaitingOrder, [FabricationJobState.ReadyForProduction]],
  [FabricationJobState.ReadyForProduction, [FabricationJobState.InProduction]],
  [FabricationJobState.InProduction, [FabricationJobState.Completed]]
]);

export function getAvailableJobTransitions(state: FabricationJobState): readonly FabricationJobState[] {
  return allowedTransitions.get(state) ?? [];
}

/**
 * Why does this matter to the UI? These two targets rewrite the fabrication
 * status of every quote item on the job, so the panel confirms before firing
 * them and names the item count in the prompt.
 */
export function transitionAffectsQuoteItems(target: FabricationJobState): boolean {
  return target === FabricationJobState.InProduction || target === FabricationJobState.Completed;
}

/**
 * Can a job in this state still be put on a purchase order? Past Draft, because a Draft job's
 * items are not settled, and before production starts, because by then the materials have been
 * ordered or the job is going ahead without them.
 *
 * State only - callers add their own fabricator-mode and lock checks, so this stays a fact about
 * the lifecycle rather than about who is looking at it.
 */
export function canJobJoinPurchaseOrder(state: FabricationJobState): boolean {
  return state === FabricationJobState.Planned || state === FabricationJobState.AwaitingOrder;
}
